module.exports = __webpack_public_path__ + "static/media/015-el-salvador.cb844eb7.svg";